module.exports = __webpack_public_path__ + "img/nautilus-19.e8078195.png";